import React, { useState } from "react";
import IcAndamento from "../Svg/IcAndamento";
import IcFinalizada from "../Svg/IcFinalizada";
import IcNaoLida from "../Svg/IcNaoLida";
import IcPrincipal from "../Svg/IcPrincipal";
import styleButton from "../../components/Button/Button.module.css";
import { ModalNewMessage } from "../../components/Modal";
import styles from "./SidebarAtendimento.module.css";
import BoxCheckbox from "../BoxCheckbox";
import useWrapper from "../../hooks/useWrapper";
import MenuItem from "../MenuItem";

export default function SidebarAtendimento({ count, setFilter, filter }) {
  const { me } = useWrapper();
  const [show, setShow] = useState(false);
  const permissions = !!me.permissions && JSON.parse(me.permissions);
  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);
  const handleCheckboxChange = event => {
    if (event.target.name === filter?.status) {
      setFilter({
        ...filter,
        status: "",
      });
    } else {
      setFilter({
        ...filter,
        status: event.target.name,
      });
    }
  };

  return (
    <>
      <div className={styles.sideBar}>
        {(permissions?.attendance?.create || me.type === "Formando") && (
          <div className={styles.sideBarBlock}>
            <div className={styles.paddingBlock}>
              <button className={`${styleButton.button_primary} d-block w-100`} onClick={handleShow}>
                Novo Atendimento
              </button>
            </div>
            <ModalNewMessage onHide={handleClose} show={show} />
          </div>
        )}
        <div className="divisor mb-3"></div>
        <div className="d-lg-block d-none">
          <MenuItem
            data-active={!filter?.andamento}
            onClick={() => {
              setFilter({
                ...filter,
                andamento: null,
                status: null,
              });
            }}
          >
            <span>
              <IcPrincipal /> Ativos
            </span>
            <span>{count?.total || 0}</span>
          </MenuItem>
          <MenuItem
            data-active={filter?.andamento === "naoIniciadas"}
            onClick={() => {
              setFilter({
                ...filter,
                andamento: "naoIniciadas",
                status: null,
              });
            }}
          >
            <span>
              <IcNaoLida /> Não Iniciadas
            </span>
            <span>{count?.naolidos || 0}</span>
          </MenuItem>
          <MenuItem
            data-active={filter?.andamento === "emAndamento"}
            onClick={() => {
              setFilter({
                ...filter,
                andamento: "emAndamento",
                status: null,
              });
            }}
          >
            <span>
              <IcAndamento /> Em Andamento
            </span>
            <span>{count?.andamento || 0}</span>
          </MenuItem>
          <MenuItem
            data-active={filter?.andamento === "finalizadas"}
            onClick={() => {
              setFilter({
                ...filter,
                andamento: "finalizadas",
                status: null,
              });
            }}
          >
            <span>
              <IcFinalizada /> Finalizadas
            </span>
            <span>{count?.finalizados || 0}</span>
          </MenuItem>
          <div>
            <div className={`${styles.sideBarBlock} ${styles.sideBarBlockPd}`}>
              <h3 className="form-title mb-3">Filtrar por Status</h3>
              <div className="d-flex flex-column">
                {!filter?.andamento || filter?.andamento === "naoIniciadas" || filter?.andamento === "emAndamento" ? (
                  <>
                    <BoxCheckbox
                      label="Aguardando Formando"
                      name="aguardandoFormando"
                      status={filter?.status === "aguardandoFormando"}
                      onChange={handleCheckboxChange}
                      className={filter?.status === "aguardandoFormando" ? "active" : ""}
                      colorScheme="ok"
                    />
                    <BoxCheckbox
                      label="Aguardando Equipe"
                      name="aguardandoEquipe"
                      status={filter?.status === "aguardandoEquipe"}
                      onChange={handleCheckboxChange}
                      className={filter?.status === "aguardandoEquipe" ? "active" : ""}
                      colorScheme="warning"
                    />
                    {me?.type !== "Formando" && (
                      <BoxCheckbox
                        label="Urgente"
                        name="urgente"
                        status={filter?.status === "urgente"}
                        onChange={handleCheckboxChange}
                        className={filter?.status === "urgente" ? "active" : ""}
                        colorScheme="error"
                      />
                    )}
                  </>
                ) : (
                  <>
                    <BoxCheckbox
                      label="Resolvido"
                      name="resolvido"
                      status={filter?.status === "resolvido"}
                      onChange={handleCheckboxChange}
                      className={filter?.status === "resolvido" ? "active" : ""}
                      colorScheme="success"
                    />
                    <BoxCheckbox
                      label="Cancelado"
                      name="cancelado"
                      status={filter?.status === "cancelado"}
                      onChange={handleCheckboxChange}
                      className={filter?.status === "cancelado" ? "active" : ""}
                      colorScheme="disabled"
                    />
                  </>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
